import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=c5779bb8&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=c5779bb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5779bb8",
  null
  
)

export default component.exports